<app-navbar title="Sekcje">
	@if (listChange) {
		<button class="me-4" mat-raised-button color="primary" (click)="save(matData)">
			<i class="fas fa-check"></i>
			Zapisz
		</button>
	}
	<button class="me-4" mat-raised-button color="primary" routerLink="./add">
		<i class="fas fa-plus"></i>
		Dodaj
	</button>
</app-navbar>

<div class="row filters-row m-2">
	<div class="col-md-10">
		<input
			type="text"
			class="form-control w-100"
			(keyup)="refreshFilter()"
			[(ngModel)]="filterValue"
			placeholder="Filtrowanie (min. 3 znaki)"
		/>
	</div>
	<div class="col-md-2 text-center">
		<button class="me-4" mat-raised-button color="primary" (click)="filtersOpen()">
			<i class="fas fa-filter"></i>
		</button>
	</div>
</div>

<app-section-filter
	[kinds]="service.kindSet"
	(selected)="filtersSelected($event)"
	[forceFilters]="{ limit: 9999 }"
></app-section-filter>

<mat-table #dataTable [dataSource]="matData" matSort cdkDropList (cdkDropListDropped)="dropTable($event)">
	<ng-container matColumnDef="name">
		<mat-header-cell *matHeaderCellDef class="mat-cell-big"> Nazwa sekcji </mat-header-cell>
		<mat-cell *matCellDef="let element" class="mat-cell-big">{{ element.name }}</mat-cell>
	</ng-container>
	<ng-container matColumnDef="kind">
		<mat-header-cell *matHeaderCellDef class="mat-cell-big"> Typ </mat-header-cell>
		<mat-cell *matCellDef="let element" class="mat-cell-big">{{ getKind(element.kind) }}</mat-cell>
	</ng-container>
	<ng-container matColumnDef="isActive">
		<mat-header-cell *matHeaderCellDef class="mat-cell-big"> Czy aktywna </mat-header-cell>

		<mat-cell *matCellDef="let element">
			@if (element.isActive) {
				<i class="fa-solid fa-check ms-2"></i>
			}
		</mat-cell>

		>
	</ng-container>
	<ng-container matColumnDef="edit">
		<mat-header-cell *matHeaderCellDef></mat-header-cell>
		<mat-cell *matCellDef="let element">
			<button mat-raised-button color="primary" routerLink="/www/section/{{ element.id }}/">Edytuj</button>
		</mat-cell>
	</ng-container>

	<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
	<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag></mat-row>
</mat-table>
